import { useTranslation } from "react-i18next";
import MainApi from "../../../../services/mainApi.service";
import { useNavigate } from "react-router-dom";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { IListImportAutomations } from "../../../../models/list-import-automation";
import { Chip } from "@mui/material";
import { enUS, es, ptBR } from "date-fns/locale";
import { format } from "date-fns";
import { dateOnlyStringToNewDate } from "../../../../utils/conversions";

const LIST_IMPORT_AUTOMATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/ListImportAutomation/";
const listImportAutomationSevice = new MainApi<IListImportAutomations>(
  LIST_IMPORT_AUTOMATION_ROUTE,
);

const translationPath = "page.4uDlist.listImportAutomation.";

const ListImportAutomationPage = () => {
  const navigate = useNavigate();

  const {
    t,
    i18n: { language },
  } = useTranslation();

  const columns: GridColDef<IListImportAutomations>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "initialDate",
      headerName: t(translationPath + "initial_date") || "Initial Date",
      renderCell: (params) => {
        if (!params.value) return "-";

        const initialDate = dateOnlyStringToNewDate(params.value);
        return format(initialDate, "P", {
          locale:
            language === "pt-BR" ? ptBR : language === "en-US" ? enUS : es,
        });
      },
    },
    {
      field: "endDate",
      headerName: t(translationPath + "end_date") || "End Date",
      renderCell: (params) => {
        if (!params.value) return "-";

        const endDate = dateOnlyStringToNewDate(params.value);
        return format(endDate, "P", {
          locale:
            language === "pt-BR" ? ptBR : language === "en-US" ? enUS : es,
        });
      },
    },
    {
      field: "enable",
      headerName: t(translationPath + "active") || "Active",
      maxWidth: 150,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            label={
              params.value
                ? t(translationPath + "enabled")
                : t(translationPath + "disabled")
            }
            color={params.value ? "success" : "error"}
          />
        );
      },
    },
  ];

  const handleAdd = () => {
    navigate("new");
  };

  const handleRowClick = (params: GridRowParams<IListImportAutomations>) => {
    navigate(`${params.id.toString()}/edit`);
  };

  return (
    <Table<IListImportAutomations>
      showDefaultMacroFilters={false}
      service={listImportAutomationSevice}
      columns={columns}
      title={t(translationPath + "title")}
      searchInput
      onAdd={handleAdd}
      onRowClick={handleRowClick}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a list import automation"
      }
      addButtonLabel={
        t(translationPath + "add") || "Add List Import Automation"
      }
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default ListImportAutomationPage;
